import { render } from "./Unauthorized.vue?vue&type=template&id=8ca7ffc2&scoped=true"
import script from "../js/unauthorized.js?vue&type=script&lang=js"
export * from "../js/unauthorized.js?vue&type=script&lang=js"

import "./Unauthorized.vue?vue&type=style&index=0&id=8ca7ffc2&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ca7ffc2"]])

export default __exports__